<template>
  <b-container fluid class="p-5">
    <b-row>
      <b-col md="12" class="text-right">
        <router-link to="/contact">
          <font-awesome-icon icon="times-circle" size="2x"></font-awesome-icon>
        </router-link>
      </b-col>
    </b-row>
    <b-row class="vh-100">
      <b-col md="12" class="text-center d-flex flex-column justify-content-center">
        <div>
          <font-awesome-icon
              :icon="['fas', 'check-circle']"
              size="3x"
              class="mb-3"
          />
          <p>
            Thank you for reaching out! <br/>
            We'll get in touch within 24 hours.
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
name: "ContactFormSuccess"
}
</script>

<style lang="scss" scoped>
  div {
    svg {
      color: $light-blue;
    }
  }
</style>